export default "__VITE_ASSET__C$XY$bK6__"